import { nsContract, nsTerminal } from '@/app/i18n/namespaces';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import EVENT_TYPE from '../../terminals/enums/EventType';
import APPLICATIONS from '../../contracts/enums/ItpRegex';
import TRANSACTION_TYPE from '../../terminals/enums/TransactionType';
import AUTHORIZATION_CODE_OPTIONS from '../../terminals/enums/AuthorizationCodeOptions';
import AUTHORIZATION_CODE_RESULT from '../../terminals/enums/AuthorizationCodeResult';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        entity: 'transactions_created_at'
    },
    LOCAL_TRANSACTION_DATE_TIME: {
        key: 'localTransactionDateTime',
        type: FIELD_TYPES.DATE,
        entity: 'keys.transactions.local_transaction_date_time',
        namespace: nsTerminal,
        filter: FILTER_TYPES.DATE,
        isLocalDateAndTime: true,
        enableSorting: false
    },
    PAN: {
        key: 'pan',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.pan',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.pan',
        enableSorting: false
    },
    EXPIRATION_DATE: {
        key: 'expirationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.transactions.expiration_date',
        namespace: nsTerminal,
        filter: FILTER_TYPES.DATE,
        enableSorting: false
    },
    AMOUNT: {
        key: 'amount',
        type: FIELD_TYPES.NUMBER,
        entity: 'keys.transactions.amount',
        namespace: nsTerminal,
        filter: FILTER_TYPES.NUMBER,
        enableSorting: false
    },
    CURRENCY: {
        key: 'currency',
        type: FIELD_TYPES.TEXT
    },
    AUTHORIZATION_NUMBER: {
        key: 'authorizationNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.authorization_number',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.authorization_number',
        enableSorting: false
    },
    AUTHORIZATION_CODE: {
        key: 'authorizationCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.authorization_code',
        namespace: nsTerminal,
        filter: FILTER_TYPES.SELECT,
        enum: AUTHORIZATION_CODE_OPTIONS,
        enableSorting: false,
        sortOptions: true,
        specialPrefix: 'authorizationCode_'
    },
    AUTHORIZATION_CODE_RESULT: {
        key: 'authorizationCodeResult',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.authorization_code_result',
        namespace: nsTerminal,
        filter: FILTER_TYPES.SELECT,
        enum: AUTHORIZATION_CODE_RESULT,
        enableSorting: false
    },
    TYPE: {
        key: 'type',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.type',
        namespace: nsTerminal,
        filter: FILTER_TYPES.SELECT,
        enum: TRANSACTION_TYPE,
        enableSorting: false
    },
    CONTRACT: {
        key: 'contract',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.contract',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.contract',
        enableSorting: false
    },
    CONTRACT_PROFILE_LABEL: {
        key: 'contractProfileLabel',
        type: 'textarea',
        entity: 'transactions_contract_profile_label'
    },
    APPLICATION: {
        key: 'application',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.application',
        namespace: nsContract,
        filter: FILTER_TYPES.SELECT,
        enum: APPLICATIONS,
        enableSorting: false,
        sortOptions: true
    },
    RECONCILIATION_NUMBER: {
        key: 'reconciliationNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.reconciliation_number',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.reconciliation_number',
        enableSorting: false
    },
    POS_REMITTANCE_NUMBER: {
        key: 'posRemittanceNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.pos_remittance_number',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.pos_remittance_number',
        enableSorting: false
    },
    CARD_DETAILS: {
        key: 'cardDetails',
        type: 'textarea',
        entity: 'transactions_card_details',
        TYPE: {
            parentKeys: ['cardDetails'],
            key: 'type',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.transactions.card_type',
            namespace: nsTerminal,
            enableSorting: false,
            isNested: true
        },
        PRODUCT: {
            parentKeys: ['cardDetails'],
            key: 'product',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.transactions.card_product',
            namespace: nsTerminal,
            enableSorting: false,
            isNested: true
        }
    },
    RANK: {
        key: 'rank',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.rank',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.rank',
        enableSorting: false
    },
    BANK_CODE: {
        key: 'bankCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.bank_code',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.bank_code',
        enableSorting: false
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        UUID: {
            parentKeys: ['posTerminal'],
            key: 'uuid'
        },
        SERIAL_NUMBER: {
            parentKeys: ['posTerminal'],
            key: 'serialNumber',
            type: 'text',
            entity: 'transactions_pos_terminal_serial_number'
        },
        MANUFACTURER: {
            parentKeys: ['posTerminal'],
            key: 'manufacturer',
            type: 'text',
            entity: 'transactions_pos_terminal_manufacturer'
        },
        LABEL: {
            parentKeys: ['posTerminal'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.label',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.label',
            enableSorting: false,
            isNested: true
        }
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.legal_name',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.legal_name',
        enableSorting: false
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.registration_number',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.registration_number',
        enableSorting: false
    },
    REMOTE_COLLECTION_UUID: {
        key: 'remoteCollectionUuid'
    },
    FILE_NUMBER: {
        key: 'fileNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.file_number',
        namespace: nsTerminal,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.transactions.file_number',
        tooltip: 'tooltip.transactions.file_number',
        enableSorting: false
    },
    EVENT_TYPE: {
        key: 'eventType',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.transactions.event_type',
        namespace: nsTerminal,
        filter: FILTER_TYPES.SELECT,
        enum: EVENT_TYPE,
        enableSorting: false
    },
    EMERGENCY_STATUS: {
        key: 'emergencyRemoteCollectionStatus',
        type: 'select',
        entity: 'emergency_remote_collection_status',
        prefix: 'emergency_remote_collection_status_'
    },
    ORIGIN_APPLICATION: {
        key: 'originApplication'
    }
};